import OnboardStepper from './OnboardStepper';

export default OnboardStepper;
